import type { InjectionKey, Component } from 'vue'

/**
 * En injection key som gör att periscope/microscope kan "ge" sin router-link-komponent
 * till delade-komponenter utan att shared behöver veta vilken router som används.
 *
 * Exempel:
 * I periscope (Vue 2 Router):
 * import { RouterLink } from 'vue-router'
 * provide(APP_LINK_COMPONENT, RouterLink)
 *
 * I microscope (Vue 3 Router):
 * import { RouterLink } from 'vue-router'
 * provide(APP_LINK_COMPONENT, RouterLink)
 **/
export const APP_LINK_COMPONENT = Symbol() as InjectionKey<Component>

// Generisk typ — ingen vue-router-import
export type RouteLocation = string | Record<string, unknown>

/**
 * En injection key som låter AppTableRow dela sin routeLocation-prop nedåt till alla AppTableCell-childs.
 * Istället för att varje cell behöver en egen route-prop.
 *
 * Exempel:
 * <!-- Med injection — sätts en gång på raden -->
 * <AppTableRow :route-location="{ name: 'user', params: { id } }">
 *   <AppTableCell>Namn</AppTableCell>    <!-- ärver route automatiskt -->
 *   <AppTableCell>Email</AppTableCell>   <!-- ärver route automatiskt -->
 *   <AppTableCell action>Radera</AppTableCell>  <!-- action=true → ingen länk -->
 * </AppTableRow>
 **/
export const APP_TABLE_ROW_ROUTE_LOCATION = Symbol() as InjectionKey<RouteLocation>
